import { useForm } from '@mantine/form'
import React from 'react'
import { modals } from '@mantine/modals'
import { Button, Flex, LoadingOverlay, TextInput } from '@mantine/core'
import {
    IRequestUpdateUser,
    IResponseGetAllUsersRowData,
} from '@apiinterface/IUser'
import User from '@api/User'
import InputUserRole from '@components/inputs/quiz/InputUserRole'

const FormEditUser = ({
    refresh,
    olddata,
    user_id,
}: {
    refresh: () => {}
    olddata: IResponseGetAllUsersRowData
    user_id: number
}) => {
    const form = useForm<IRequestUpdateUser>({
        initialValues: {
            username: olddata.username,
            first_name: olddata.first_name,
            last_name: olddata.last_name,
            role: olddata.role_id,
            email: olddata.email,
        },
    })
    const { onSubmit, isLoading } = User.useUpdateUser({
        user_id: user_id,
        form: form,
        aftersuccess: modals.closeAll,
    })
    return (
        <form onSubmit={onSubmit}>
            <LoadingOverlay visible={isLoading} overlayProps={{ blur: 2 }} />
            <Flex direction='column' gap='md'>
                <TextInput
                    styles={{
                        input: {
                            borderColor: 'var(--mantine-color-gray-2)',
                        },
                    }}
                    {...form.getInputProps('first_name')}
                    label='ชื่อจริง'
                    placeholder='ชื่อจริง '
                    data-autofocus
                />
                <TextInput
                    styles={{
                        input: {
                            borderColor: 'var(--mantine-color-gray-2)',
                        },
                    }}
                    {...form.getInputProps('last_name')}
                    label='นามสกุล'
                    placeholder='นามสกุล '
                    data-autofocus
                />
                <TextInput
                    styles={{
                        input: {
                            borderColor: 'var(--mantine-color-gray-2)',
                        },
                    }}
                    {...form.getInputProps('username')}
                    label='ชื่อผู้ใช้งาน'
                    placeholder='ชื่อผู้ใช้งาน '
                    data-autofocus
                />
                <TextInput
                    styles={{
                        input: {
                            borderColor: 'var(--mantine-color-gray-2)',
                        },
                    }}
                    {...form.getInputProps('email')}
                    label='อีเมล:'
                    placeholder='อีเมล '
                />
                <InputUserRole
                    styles={{
                        input: {
                            borderColor: 'var(--mantine-color-gray-2)',
                        },
                    }}
                    {...form.getInputProps('role')}
                    label='สิทธิการใช้งาน:'
                    placeholder='สิทธิการใช้งาน '
                />

                <Button
                    fullWidth
                    type='submit'
                    radius='10px'
                    mt='md'
                    color='#e6007e'
                >
                    ยืนยัน
                </Button>
            </Flex>
        </form>
    )
}

export default FormEditUser
